import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Checkbox,
  Fab,
  FormGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Grid,
  Tooltip,
  Radio, RadioGroup
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { CboCentrosMedicos } from "../../cbos/CboCentrosMedicos";
import { CboEspecialidades } from "../../cbos/CboEspecialidades";
import { CboProfesionales } from "../../cbos/CboProfesionales";
import {
  ValidatorForm,
} from "react-material-ui-form-validator";
import { agendaLimpiar, fetchDiasAgenda, fetchPrimerTurnoDisponible } from "../../../actions/turnos/agenda";
import { CalendarioTurno } from "./CalendarioTurno";
import { PrimerTurno } from "./PrimerTurno";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { ModalAltaSobreturno } from "./ModalAltaSobreturno";
// import { validarSoloUnPermiso } from '../../../helpers/permisos';
// import { TURNOS_PERMISOS } from "../../../utils/permisos";
// import { armarParametros } from "../../../helpers/parametros";
// import { fetchConToken } from "../../../helpers/fetch";
// import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
// import { startAlerta } from "../../../actions/ui/alertas";
import { ModalFamiliares } from "./ModalFamiliares";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    paddingTop: 35,
    // width: "80%",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  botonera: {
    marginTop: 25,
  },
  NroAfi: {
    fontSize: 15,
  },
  hideButton: {
    display: "none",
  },
}));

export const ParametrosTurno = React.memo((props) => {

  const classes = useStyles();
  moment.locale("es");
  const dispatch = useDispatch();
  const { itemsDias, seleccionado } = useSelector((state) => state.agenda);
  const { afiliado } = useSelector((state) => state.afiliacion);
  const { items: itemsGrupoFamiliar } = useSelector((state) => state.grupofamiliar);
  // const { permisos: permisosUser } = useSelector(state => state.auth)
  const { otroTurno, setOtroTurno, presencial, setPresencial, virtual, setVirtual, idEspecialidad, idCentroMedico,
    idProfesional, primeroDisponible, handleInputChange, setPrimeroDisponible, filtrarEdad, handleChangeFiltrarEdad,
    handleInputChangePorProfesional, idObraSocial, desdeHce } = props;
  
  // const [permiteSobreturno, setPermiteSobreturno] = useState(false);
  const [porEspecialidad, setPorEspecialidad] = useState(desdeHce ? 'false' : 'true');
  const [listaHorarios, setListaHorarios] = useState([]);
  const [openFamiliares, setOpenFamiliares] = React.useState(false);
  const [open, setOpen] = useState(false);
  const error = (!presencial && !virtual);

  const handleSearchAvailableDates = () => {
    if(!error)
      dispatch( agendaLimpiar() );
      if(primeroDisponible)
        dispatch( fetchPrimerTurnoDisponible(idEspecialidad, idCentroMedico, idProfesional, presencial, virtual) );
      else
        dispatch( fetchDiasAgenda(idEspecialidad, idCentroMedico, idProfesional, presencial, virtual) );
  };

  useEffect(() => {
    dispatch( agendaLimpiar() );
  }, [dispatch]);

  useEffect(() => {
    dispatch( agendaLimpiar() );
  }, [idCentroMedico, idProfesional, primeroDisponible, presencial, virtual, filtrarEdad, dispatch]);

  /* useEffect(() => {
    const verificarParametrizacion = async () => {
      try{
          dispatch(startSpinner());
          const parametros = armarParametros(idEspecialidad, idCentroMedico, idProfesional);
          const response = await fetchConToken(`EfectorPSobreturnos/traerPorParametros?${parametros}`);
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.indexOf("application/json") !== -1) {
              const lista = await response.json();
              if (response.status !== 200) throw lista.errores;
              if(lista.length > 0)
                  setPermiteSobreturno(true);
          }
          dispatch(finishSpinner());
      } catch (err){
          dispatch(finishSpinner());
          dispatch(startAlerta(err, "warning", `¡Error!`));
      }
    };
    setPermiteSobreturno(false);
    idProfesional&& idCentroMedico&& verificarParametrizacion();
  }, [dispatch, idEspecialidad, idCentroMedico, idProfesional]); */

  const handleClickNuevoSobreturno = () => {
    dispatch( agendaLimpiar() );
    setListaHorarios([]);
    setOpen(true);
  }

  const handleChangePorEspecialidad = e => {
    setPorEspecialidad(e.target.value);
    handleInputChangePorProfesional({target:{name: 'idProfesional', value: null}});
  }

  return (
      <>
        <ValidatorForm onSubmit={handleSearchAvailableDates}>
            <div className={classes.root}>
            <Grid container justify="center" spacing={1} style={{marginTop: 0}}>
              <FormControl component="div">
                <RadioGroup row aria-label="gender" name="porEspecialidad" value={porEspecialidad} onChange={handleChangePorEspecialidad} >
                  <FormControlLabel value='true' control={<Radio />} label="Especialidad" disabled={desdeHce ? true : false}/>
                  <FormControlLabel value='false' control={<Radio />} label="Profesional" />
                </RadioGroup>
              </FormControl>
              </Grid>
              <Grid container spacing={1}>
                  <Grid item container justify="center">
                    <FormControl required error={error} component="fieldset" >
                      <FormGroup row>
                          <FormControlLabel
                              control={
                              <Checkbox
                                  name="presencial"
                                  checked={presencial}
                                  onChange={() => setPresencial(!presencial)}
                              />
                              }
                              label="Presencial"
                          />
                          <FormControlLabel
                              control={
                              <Checkbox
                                  name="virtual"
                                  checked={virtual}
                                  onChange={() => setVirtual(!virtual)}
                              />
                              }
                              label="Virtual"
                          />
                          <FormControlLabel
                              style={{marginLeft: 50}}
                              control={
                              <Checkbox
                                  name="filtrarEdad"
                                  checked={!filtrarEdad}
                                  onChange={() => handleChangeFiltrarEdad(!filtrarEdad)}
                              />
                              }
                              label="No filtrar edad"
                          />
                      </FormGroup>
                      {error&&
                        <FormHelperText>Debe incluir el Tipo de Turno </FormHelperText>
                      }
                    </FormControl>
                  </Grid>
              </Grid>  
              
              {porEspecialidad==='true'
                ?
                  <>
                    <Grid container justify="center" spacing={1} style={{marginTop: -20}}>
                        <Grid item xs={12} md={4}>
                            <CboEspecialidades
                                manejadorInputChange={handleInputChange}
                                valor={idEspecialidad}
                                idPanel={props.idPanel}
                                filtrarEdad={filtrarEdad}
                                edadAfiliado={moment().diff(moment(afiliado.fecha_nacimiento), "years", false)}
                            />
                        </Grid>
                    </Grid>

                    <Grid container justify="center" spacing={4}>
                        <Grid item xs={12} md={4}>
                            <CboCentrosMedicos
                                manejadorInputChange={handleInputChange}
                                valor={idCentroMedico}
                                idEspecialidad={idEspecialidad}
                                idProfesional={idProfesional}
                                idPanel={props.idPanel}
                                cargarEnCascada={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <CboProfesionales
                                manejadorInputChange={handleInputChange}
                                valor={idProfesional}
                                idEspecialidad={idEspecialidad}
                                idCentroMedico={idCentroMedico}
                                idPanel={props.idPanel}
                                cargarEnCascada={true}
                                desdeHce={desdeHce}
                            />
                        </Grid>
                    </Grid>
                  </>
                :
                  <>
                    <Grid container justify="center" spacing={1} style={{marginTop: -20}}>
                      <Grid item xs={12} md={4}>
                          <CboProfesionales
                              autocomplete={true}
                              valor={idProfesional}
                              idPanel={props.idPanel}
                              filtrarEdad={filtrarEdad}
                              filtrarPorUsuario={true}
                              conEspecialidad={true}
                              manejadorInputChange={handleInputChangePorProfesional}
                              edadAfiliado={moment().diff(moment(afiliado.fecha_nacimiento), "years", false)}
                              desdeHce={desdeHce}
                          />
                      </Grid>
                    </Grid>

                    <Grid container justify="center" spacing={4}>
                      <Grid item xs={12} md={4}>
                          <CboCentrosMedicos
                              porProfesional={true}
                              cargarEnCascada={true}
                              valor={idCentroMedico}
                              idPanel={props.idPanel}
                              idProfesional={idProfesional}
                              idEspecialidad={idEspecialidad}
                              manejadorInputChange={handleInputChangePorProfesional}
                          />
                      </Grid>
                      <Grid item xs={12} md={4}>
                          <CboEspecialidades
                              porProfesional={true}
                              cargarEnCascada={true}
                              valor={idEspecialidad}
                              idPanel={props.idPanel}
                              filtrarEdad={filtrarEdad}
                              idProfesional={idProfesional}
                              idCentroMedico={idCentroMedico}
                              manejadorInputChange={handleInputChangePorProfesional}
                              edadAfiliado={moment().diff(moment(afiliado.fecha_nacimiento), "years", false)}
                          />
                      </Grid>
                    </Grid>
                  </>
              }

              <Grid container spacing={1}>
                  <Grid item container justify="center">
                      <FormGroup row>
                          <FormControlLabel
                              control={
                              <Checkbox
                                  name="primeroDisponible"
                                  checked={primeroDisponible}
                                  onChange={() => setPrimeroDisponible(!primeroDisponible)}
                              />
                              }
                              label="Primero Disponible"
                          />
                      </FormGroup>
                      <Button 
                          id="btnConsultarTurnos" 
                          type="submit"
                          variant="contained"
                      >
                          Consultar
                      </Button>
                      {idEspecialidad&& idCentroMedico&& idProfesional&&
                        <Tooltip title="Agregar Sobreturno">
                          <Fab
                            style={{marginLeft: 50}}
                            size="medium"
                            onClick={handleClickNuevoSobreturno}
                            // disabled={!validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.SOBRETURNOS) || !permiteSobreturno}
                          >
                            <AddCircleIcon style={{fontSize: 30}}/>
                          </Fab>
                        </Tooltip>
                      }
                      {open &&
                        <ModalAltaSobreturno 
                          open={open} 
                          setOpen={setOpen} 
                          title={'Nuevo Sobreturno'}
                          idEspecialidad={idEspecialidad}
                          idCentroMedico={idCentroMedico}
                          idProfesional={idProfesional}
                          presencial={presencial}
                          virtual={virtual} 
                          listaHorarios={listaHorarios}
                          setListaHorarios={setListaHorarios}
                          setOtroSobreTurno={setOtroTurno}
                          idObraSocial={idObraSocial}
                        />
                      }
                  </Grid>
              </Grid>  
            </div>
        </ValidatorForm>
        {itemsGrupoFamiliar.length > 1 && otroTurno &&
          <>
            <Fab variant="extended" onClick={() => {setOpenFamiliares(true)}}>
                <SupervisorAccountIcon style={{marginRight: 10}} />
                Familiares
            </Fab>
            <ModalFamiliares
              open={openFamiliares}
              idAfiliado={afiliado.idAfiliado}
              grupoFamiliar={itemsGrupoFamiliar}
              handleClose={() => {setOpenFamiliares(false)}}
            />
          </>
        }
        {itemsDias.length > 0 && !primeroDisponible
          ?
            <CalendarioTurno
              idEspecialidad={idEspecialidad}
              idCentroMedico={idCentroMedico}
              idProfesional={idProfesional}
              presencial={presencial}
              virtual={virtual}
            />
          :
            null
        }
        {primeroDisponible && seleccionado !== null 
          ?
            <PrimerTurno 
            idObraSocial={idObraSocial} />
          :
            null
        }
      </>
  );
});
